import React from 'react';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import CV from './pages/CV.jsx';
import Contact from './pages/Contact.jsx';
import Stories from './pages/Stories.jsx';
import Story from './pages/Story.jsx';
import Admin from './pages/Admin.jsx';
import './App.css';
import './globalStyles.css';
import LeftColumn from './components/LeftColumn.jsx';
import MobileHeader from './components/MobileHeader.jsx';
import MobileLeftColumn from './components/MobileLeftColumn.jsx';
import { AuthProvider } from './contexts/AuthContext.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';

import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from "react-router-dom";

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="app-container">
      <LeftColumn />
      <MobileHeader />

      <div className="content-area">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/CV" element={<CV />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/stories/:slug" element={<Story />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>

        {isHomePage && <MobileLeftColumn />}
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
